import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AlertsConfigurationResponse {
	alerts: AlertConfigModel[];
}

export interface AlertConfigModel {
  id: string;
  title: string;
  description: string;
  dispatch: AlertDispatchModel;
  triggerExpressions: string[];
  categories: Record<string, TemplateConfigModel>;
}

export interface AlertDispatchModel {
  realTime: boolean,
  weekDays: string,
  delayDays: number,
  delayHours: number,
  delayFromNow: boolean,
  timeUtc: string
}

export interface TemplateConfigModel {
  notification: {
    renderMode: string | null;
    source: string | null;
    categoryType: string | null;
    provider: string | null;
    externalRefID: string | null;
    plainText: string | null;
    htmlText: string | null;
    subject: string | null;
    senderName: string | null;
    senderAddress: string | null;
    receivers: string | null;
    attachments: string | null;
    weekDays: string | null;
    dispatchUTCFrom: string;
    dispatchUTCTo: string;
    batchId: string | null;
    weekDaysConfig: string | null;
    cidContent: string[]
    validTranslationKey: Record<string, string>
  };
  distributions: AlertDistributionModel[];
  triggers: Record<string, AlertTriggerModel>;
  emailTemplate: EmailTemplateModel;
}

export interface EmailTemplateModel {
  urlTemplate: string;
  urlTemplateRTL: string;
  subject: string;
  fromText: string;
  emailFromAddress: string;
  useCIDImage: boolean;
  cidContent: {containerName: string; attachmentName: string; attachmentURI: string;}[];
  notifyIfOnlyContact: string;
  validTranslationKey: Record<string, string>;
  optionalTags: Record<string, OptionalTagModel>;
}

export interface OptionalTagModel {
  type: string;
  segments: string[];
}

export interface AlertDistributionModel {
  id: string;
  cmdPropField: string | null;
  cmdPropValue: string | null
}

export interface AlertTriggerModel {
  expression: string;
  expressionCode: string;
  expressionDescription: string;
  dl: string[];
}

@Injectable({ providedIn: 'root' })
export class ApiAlertsConfigurationService {
  private readonly apiBaseUrl = environment.apiBaseUrl;
  private readonly apiPath = '/alertsconfiguration';

  constructor(
    private http: HttpClient) {}

  getConfiguration(organizationId: string, surveyId: string): Observable<AlertsConfigurationResponse> {
    const params = new HttpParams()
          .set('organization', organizationId)
          .set('survey', surveyId);
        
    return this.http.get<AlertsConfigurationResponse>(`${this.apiBaseUrl}${this.apiPath}`, {params})
  }
}